"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trimmer = void 0;

var _sampleFrame = _interopRequireDefault(require("../../assets/img/sample-frame.png"));

var _react = _interopRequireWildcard(require("react"));

var _TrimmerHandle = require("./TrimmerHandle");

var _VideoPlayer = require("../VideoPlayer");

var _atoms = require("../../atoms");

require("./TrimmerControls.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Constants
var TRACK_WIDTH = 256.0;
var SIDE_HANDLE_WIDTH = 32.0;
var MAX_CLIP_DURATION = 150.0; // Trimmer

var Trimmer = function Trimmer(_ref) {
  var _leftHandlePosition$c2, _rightHandlePosition$2, _trackPosition$curren3;

  var type = _ref.type,
      initialStartAt = _ref.initialStartAt,
      startAt = _ref.startAt,
      stopAt = _ref.stopAt,
      onChangeStop = _ref.onChangeStop,
      onChangeStart = _ref.onChangeStart,
      fullVideoDuration = _ref.fullVideoDuration,
      duration = _ref.duration,
      validTrim = _ref.validTrim,
      videoPlayerContainerRef = _ref.videoPlayerContainerRef;

  var getTrackRelativeStartTime = function getTrackRelativeStartTime() {
    var result = 0.0;

    if (type === "uploading" && fullVideoDuration > MAX_CLIP_DURATION && startAt === initialStartAt) {
      result = startAt;
    }

    return parseFloat(result);
  }; // Playhead


  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldShowPlayhead = _useState2[0],
      setShouldShowPlayhead = _useState2[1]; // Store our frames


  var _useState3 = (0, _react.useState)(Array(7).fill("sample-frame.png")),
      _useState4 = _slicedToArray(_useState3, 2),
      frames = _useState4[0],
      setFrames = _useState4[1]; // Constructing the track depends on the type of Trimming, e.g. uploading vs. editing...


  var adjustedFullVideoDuration = type === "editing" ? MAX_CLIP_DURATION : parseFloat(fullVideoDuration);

  var _useState5 = (0, _react.useState)(getTrackRelativeStartTime()),
      _useState6 = _slicedToArray(_useState5, 2),
      trackRelativeStartTime = _useState6[0],
      setTrackRelativeStartTime = _useState6[1]; // Helpers


  var convertTimeToXPosition = function convertTimeToXPosition(time) {
    // Get the x position
    var xPosition = 0;
    xPosition = parseFloat((time - 0.0) / adjustedFullVideoDuration) * TRACK_WIDTH;
    return xPosition;
  }; // Vars


  var initialLeftHandleOffset = convertTimeToXPosition(startAt);
  var initialRightHandleOffset = convertTimeToXPosition(stopAt);
  var initialMiddleHandleWidth = initialRightHandleOffset - initialLeftHandleOffset; // Positioning

  var trackPosition = (0, _react.useRef)({
    left: null,
    right: null
  });
  var leftHandlePosition = (0, _react.useRef)({
    left: initialLeftHandleOffset - SIDE_HANDLE_WIDTH,
    right: initialLeftHandleOffset
  });
  var middleHandlePosition = (0, _react.useRef)({
    left: initialLeftHandleOffset,
    right: initialRightHandleOffset
  });
  var rightHandlePosition = (0, _react.useRef)({
    left: initialRightHandleOffset,
    right: initialRightHandleOffset + SIDE_HANDLE_WIDTH
  }); // Get the middle handle

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      middleHandle = _useState8[0],
      setMiddleHandle = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      fetchingFrames = _useState10[0],
      setFetchingFrames = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = _slicedToArray(_useState11, 2),
      playbackProgress = _useState12[0],
      setPlaybackProgress = _useState12[1];

  var _useState13 = (0, _react.useState)(null),
      _useState14 = _slicedToArray(_useState13, 2),
      callOnChangeStartWith = _useState14[0],
      setCallOnChangeStartWith = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = _slicedToArray(_useState15, 2),
      callOnChangeStopWith = _useState16[0],
      setCallOnChangeStopWith = _useState16[1]; // Left Handle


  var _useState17 = (0, _react.useState)(initialLeftHandleOffset - SIDE_HANDLE_WIDTH),
      _useState18 = _slicedToArray(_useState17, 2),
      leftHandleXOffset = _useState18[0],
      setLeftHandleXOffset = _useState18[1]; // Middle Handle


  var _useState19 = (0, _react.useState)(initialLeftHandleOffset),
      _useState20 = _slicedToArray(_useState19, 2),
      middleHandleXOffset = _useState20[0],
      setMiddleHandleXOffset = _useState20[1];

  var _useState21 = (0, _react.useState)({
    position: "start",
    width: type === "uploading" ? 0 : initialMiddleHandleWidth
  }),
      _useState22 = _slicedToArray(_useState21, 2),
      middleHandleExtraWidth = _useState22[0],
      setMiddleHandleExtraWidth = _useState22[1]; // Right Handle


  var _useState23 = (0, _react.useState)(initialRightHandleOffset),
      _useState24 = _slicedToArray(_useState23, 2),
      rightHandleXOffset = _useState24[0],
      setRightHandleXOffset = _useState24[1]; // Helpers


  var convertTimeToPlaybackProgress = function convertTimeToPlaybackProgress(time) {
    var progress = 0;
    var middleHandleElem = document.querySelector(".handle.middle");
    var middleHandleRect = middleHandleElem.getBoundingClientRect();
    progress = (time - startAt) * middleHandleRect.width / duration;
    return progress;
  };

  var convertXPosToRelativeTime = function convertXPosToRelativeTime(xPos) {
    var time = 0;
    var difference = parseFloat(xPos) - parseFloat(trackPosition.current.left);
    time = parseFloat(difference / TRACK_WIDTH) * parseFloat(adjustedFullVideoDuration);
    time += parseFloat(trackRelativeStartTime);
    return parseFloat(time);
  }; // Handlers


  var handleRightHandleRepositionX = function handleRightHandleRepositionX(x) {
    setMiddleHandleExtraWidth({
      position: "end",
      width: x
    });
    setMiddleHandleExtraWidth({
      position: "end",
      width: 0
    });
  };

  var handleLeftHandleRepositionX = function handleLeftHandleRepositionX(x) {
    setMiddleHandleExtraWidth({
      position: "start",
      width: -x
    });
    setMiddleHandleXOffset(function (old) {
      return old + x;
    });
    setMiddleHandleExtraWidth({
      position: "start",
      width: 0
    });
  };

  var handleMiddleHandleRepositionX = function handleMiddleHandleRepositionX(x) {
    if (x === 0) return; // Update right handle values

    setRightHandleXOffset(function (old) {
      return old + x;
    }); // Update left handle values

    setLeftHandleXOffset(function (old) {
      return old + x;
    });
  }; // Effects


  (0, _react.useEffect)(function () {
    var middleHandleElem = document.querySelector(".handle.middle");

    if (!middleHandle && initialMiddleHandleWidth !== 0) {
      middleHandleElem.style.width = "".concat(initialMiddleHandleWidth, "px");
      middleHandleElem.style.maxWidth = "".concat(initialMiddleHandleWidth, "px");
      middleHandleElem.style.minWidth = "".concat(initialMiddleHandleWidth, "px");
      setRightHandleXOffset(initialRightHandleOffset);
      if (type === "uploading") setMiddleHandleExtraWidth({
        position: "end",
        width: initialMiddleHandleWidth
      });
      setMiddleHandle(middleHandleElem);
    }
  }, [initialMiddleHandleWidth, middleHandle]); // Get the current time of the video

  var _useVideoInfo = (0, _VideoPlayer.useVideoInfo)(videoPlayerContainerRef),
      currentTime = _useVideoInfo.currentTime,
      readyState = _useVideoInfo.readyState; // Update the playhead position


  (0, _react.useEffect)(function () {
    var newProgress = convertTimeToPlaybackProgress(currentTime);
    if (newProgress >= 0) setPlaybackProgress(convertTimeToPlaybackProgress(currentTime));
    if (!shouldShowPlayhead && readyState > 1 && newProgress >= 0) setShouldShowPlayhead(true);
  }, [currentTime, duration, readyState, playbackProgress]); // Update our track position

  (0, _react.useEffect)(function () {
    var _trackPosition$curren, _trackPosition$curren2;

    if (!((_trackPosition$curren = trackPosition.current) !== null && _trackPosition$curren !== void 0 && _trackPosition$curren.left) && !((_trackPosition$curren2 = trackPosition.current) !== null && _trackPosition$curren2 !== void 0 && _trackPosition$curren2.right)) {
      // Get the track min/max
      var trackElem = document.querySelector("#trimmer-track");
      var trackRect = trackElem.getBoundingClientRect();
      var trackLeft = trackRect.left;
      var trackRight = trackRect.right; // Set

      trackPosition.current.left = trackLeft;
      trackPosition.current.right = trackRight;
    }
  }, [trackPosition.current.left, trackPosition.current.right]); // Update our handle positions

  (0, _react.useEffect)(function () {
    var leftHandleElem = document.querySelector(".handle.left");
    var leftHandleRect = leftHandleElem.getBoundingClientRect();
    leftHandlePosition.current.left = leftHandleRect.left;
    leftHandlePosition.current.right = leftHandleRect.right;
    var middleHandleElem = document.querySelector(".handle.middle");
    var middleHandleRect = middleHandleElem.getBoundingClientRect();
    middleHandlePosition.current.left = middleHandleRect.left;
    middleHandlePosition.current.right = middleHandleRect.right;
    var rightHandleElem = document.querySelector(".handle.right");
    var rightHandleRect = rightHandleElem.getBoundingClientRect();
    rightHandlePosition.current.left = rightHandleRect.left;
    rightHandlePosition.current.right = rightHandleRect.right;
  }, [initialLeftHandleOffset, initialMiddleHandleWidth, initialRightHandleOffset, leftHandleXOffset, rightHandleXOffset, middleHandleXOffset, middleHandleExtraWidth, middleHandle]);
  (0, _react.useEffect)(function () {
    var newValue = parseFloat(callOnChangeStartWith).toFixed(2);
    onChangeStart(newValue);
  }, [callOnChangeStartWith]);
  (0, _react.useEffect)(function () {
    var newValue = parseFloat(callOnChangeStopWith).toFixed(2);
    onChangeStop(newValue);
  }, [callOnChangeStopWith]); // Monitor our left handle end and notify parent of start changes

  (0, _react.useEffect)(function () {
    var _leftHandlePosition$c;

    if (typeof onChangeStart === "function" && leftHandlePosition !== null && leftHandlePosition !== void 0 && (_leftHandlePosition$c = leftHandlePosition.current) !== null && _leftHandlePosition$c !== void 0 && _leftHandlePosition$c.right && middleHandle) {
      var newStart = convertXPosToRelativeTime(leftHandlePosition.current.right);
      setCallOnChangeStartWith(newStart);
    }
  }, [leftHandlePosition === null || leftHandlePosition === void 0 ? void 0 : (_leftHandlePosition$c2 = leftHandlePosition.current) === null || _leftHandlePosition$c2 === void 0 ? void 0 : _leftHandlePosition$c2.right, middleHandle, middleHandleXOffset]); // Monitor our right handle end and notify parent of stop changes

  (0, _react.useEffect)(function () {
    var _rightHandlePosition$;

    if (typeof onChangeStop === "function" && rightHandlePosition !== null && rightHandlePosition !== void 0 && (_rightHandlePosition$ = rightHandlePosition.current) !== null && _rightHandlePosition$ !== void 0 && _rightHandlePosition$.left && middleHandle) {
      if (rightHandlePosition.current.left !== trackPosition.current.left) {
        var newStop = convertXPosToRelativeTime(rightHandlePosition.current.left);

        if (newStop <= adjustedFullVideoDuration) {
          setCallOnChangeStopWith(newStop);
        }
      }
    }
  }, [rightHandlePosition === null || rightHandlePosition === void 0 ? void 0 : (_rightHandlePosition$2 = rightHandlePosition.current) === null || _rightHandlePosition$2 === void 0 ? void 0 : _rightHandlePosition$2.left, middleHandle, middleHandleXOffset, trackPosition === null || trackPosition === void 0 ? void 0 : (_trackPosition$curren3 = trackPosition.current) === null || _trackPosition$curren3 === void 0 ? void 0 : _trackPosition$curren3.left]);
  var addtlStylesLeft = validTrim ? {
    backgroundColor: "var(--teal-40-color)"
  } : {
    backgroundColor: "var(--error-color)"
  };
  var addtlStylesMiddle = validTrim ? {
    borderColor: "var(--teal-40-color)"
  } : {
    borderColor: "var(--error-color)"
  };
  var addtlStylesRight = validTrim ? {
    backgroundColor: "var(--teal-40-color)"
  } : {
    backgroundColor: "var(--error-color)"
  };
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "Trimmer"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "canvas-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "trimmer-track"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "draggable-container"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "dragger"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "dragger-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_TrimmerHandle.TrimmerHandle, {
    name: "left",
    addtlStyles: addtlStylesLeft,
    trackPosition: trackPosition,
    leftHandlePosition: leftHandlePosition,
    middleHandlePosition: middleHandlePosition,
    rightHandlePosition: rightHandlePosition,
    icon: _atoms.Icon.Type.CheveronLeft,
    xOffset: leftHandleXOffset,
    cn: "handle left",
    onRepositionX: handleLeftHandleRepositionX,
    maxWidth: TRACK_WIDTH
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "dim left"
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "dragger-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_TrimmerHandle.TrimmerHandle, {
    name: "middle",
    addtlStyles: addtlStylesMiddle,
    trackPosition: trackPosition,
    leftHandlePosition: leftHandlePosition,
    middleHandlePosition: middleHandlePosition,
    rightHandlePosition: rightHandlePosition,
    xOffset: middleHandleXOffset,
    extraWidth: middleHandleExtraWidth,
    cn: "handle middle",
    onRepositionX: handleMiddleHandleRepositionX,
    maxWidth: TRACK_WIDTH
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "Playhead",
    style: {
      left: "".concat(playbackProgress, "px")
    }
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "dragger-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_TrimmerHandle.TrimmerHandle, {
    name: "right",
    addtlStyles: addtlStylesRight,
    trackPosition: trackPosition,
    leftHandlePosition: leftHandlePosition,
    middleHandlePosition: middleHandlePosition,
    rightHandlePosition: rightHandlePosition,
    icon: _atoms.Icon.Type.CheveronRight,
    xOffset: rightHandleXOffset,
    cn: "handle right",
    onRepositionX: handleRightHandleRepositionX,
    maxWidth: TRACK_WIDTH
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "dim right"
  })))))));
};

exports.Trimmer = Trimmer;
Trimmer.defaultProps = {
  type: "editing"
};